/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AvailabilityZoneQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AvailabilityZoneQueryOperator");
    }

    getFixupPrototypeFunction() { return AvailabilityZoneQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AvailabilityZoneQueryOperator>): AvailabilityZoneQueryOperator {
        let obj = Object.assign(new AvailabilityZoneQueryOperator(), model);
        AvailabilityZoneQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AvailabilityZoneQueryOperator>): AvailabilityZoneQueryOperator {
        if (!model) return null;
        return AvailabilityZoneQueryOperator.newInstance(<AvailabilityZoneQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AvailabilityZoneQueryOperator) {
        if (!obj) return;

        models.AvailabilityZoneQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AvailabilityZoneQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AvailabilityZoneQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Availability zones to include
     */
    availability_zones: Array<string>;

}
